import React, { useEffect, useRef, useState } from 'react';
import { isDesktopUser } from '../../../../Utils/ProductUtils';
import { SharePopupStyle } from '../../../../Utils/redirections';
import { getPublicUrl } from '../../../../appconfig';

import {
  FacebookIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
  FacebookShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'next-share';
import { useRouter } from 'next/router';
import Modal from 'react-modal';
import { images } from '../../../../Constants/ImageUrls';
import { pushSameRouteShareButton } from '../../../../Utils/PaymentUtils/utils';
import { ModalCrossbtn } from '../../../ProductNew/TrustStrip/styled';
import {
  clicked_share_button,
  closed_share_popup,
  viewed_share_popup,
} from './instrumentation';
import {
  ButtonContainer,
  ShareButtonPdp,
  ShareContainer,
  ShareSection,
  ShareSectionNew,
} from './styled';
import { copyHandler, generateUrlWithUtm, socialShareHandler } from './utils';

export default function ShareProduct(props) {
  const { productData, setShowToast, showNewPriceSection, isFertilityProduct } =
    props;
  const [clickEffect, setClickEffect] = useState('');
  const [openShareModal, setOpenShareModal] = useState(false);
  const [fireDiscardPopupEvent, setDiscardPopupEvent] = useState(true);
  const [shareUrl, setShareUrl] = useState('');
  const [paramsExist, setParamsExist] = useState(false);
  const router = useRouter();
  const handleClose = (fireEventBool) => {
    if (fireEventBool === false) {
      setDiscardPopupEvent(false);
    } else {
      setDiscardPopupEvent(true);
    }
    router.back();
    document.getElementsByTagName('body')[0].classList.remove('noScroll');
  };
  useEffect(() => {
    if (router.query.sharepopup == 'true') {
    } else {
      setOpenShareModal(false);
    }
  }, [router.query]);
  const shareClickHandler = (e) => {
    e.stopPropagation();
    setClickEffect('lowOpacity');
    document.getElementsByTagName('body')[0].classList.add('noScroll');
    pushSameRouteShareButton(router, 'sharepopup');
    setTimeout(() => {
      setClickEffect('');
    }, 400);
    setOpenShareModal(true);
    clicked_share_button(productData);
  };
  const shareRefWA = useRef();
  const shareRefFB = useRef();
  const shareRefFM = useRef();
  const iconCursor = isDesktopUser() ? 'pointer' : 'default';
  const iconStyle = {
    cursor: iconCursor,
  };
  const BottomStylePopup = SharePopupStyle('', '', '0', '');

  useEffect(() => {
    const url = getPublicUrl() + productData?.web_url + window.location.search;
    setShareUrl(url);
    if (window.location.search.length > 0) {
      setParamsExist(true);
    }
    if (openShareModal) {
      router.beforePopState(() => {
        handleClose();
        return true;
      });
    }
  }, [productData?.id]);
  return (
    <>
      <Modal
        isOpen={openShareModal}
        onRequestClose={handleClose}
        style={BottomStylePopup}
        preventScroll={true}
        bodyOpenClassName="noScroll"
        htmlOpenClassName="noScroll"
        closeTimeoutMS={500}
        className={{
          base: 'shareModal',
          afterOpen: 'shareModalOpen',
          beforeClose: 'shareModalClose',
        }}
        onAfterOpen={() => {
          viewed_share_popup(productData);
        }}
        onAfterClose={() => {
          if (fireDiscardPopupEvent) closed_share_popup(productData);
        }}
      >
        <ShareContainer>
          <ButtonContainer>
            <ShareButtonPdp
              onClick={(e) => {
                copyHandler(
                  e,
                  shareUrl,
                  setShowToast,
                  productData,
                  paramsExist,
                );
                handleClose(false);
              }}
            >
              <img src={images.CopyIcon} alt="" />
              <span>Copy link</span>
            </ShareButtonPdp>
            <ShareButtonPdp ref={shareRefWA}>
              <WhatsappShareButton
                url={generateUrlWithUtm(
                  shareUrl,
                  'web_whatsapp_share',
                  paramsExist,
                )}
              >
                <WhatsappIcon
                  style={iconStyle}
                  onClick={() => {
                    socialShareHandler(shareRefWA, productData, 'whatsapp');
                    handleClose(false);
                  }}
                  size={40}
                  round
                />
              </WhatsappShareButton>
              <span>Whatsapp</span>
            </ShareButtonPdp>
            <ShareButtonPdp ref={shareRefFB}>
              <FacebookShareButton
                url={generateUrlWithUtm(shareUrl, 'web_fb_share', paramsExist)}
              >
                <FacebookIcon
                  style={iconStyle}
                  onClick={() => {
                    socialShareHandler(shareRefFB, productData, 'facebook');
                    handleClose(false);
                  }}
                  size={40}
                  round
                />
              </FacebookShareButton>
              <span>Facebook</span>
            </ShareButtonPdp>
            <ShareButtonPdp ref={shareRefFM}>
              <FacebookMessengerShareButton
                url={generateUrlWithUtm(
                  shareUrl,
                  'web_fb_messenger_share',
                  paramsExist,
                )}
              >
                <FacebookMessengerIcon
                  style={iconStyle}
                  onClick={() => {
                    socialShareHandler(shareRefFM, productData, 'messenger');
                    handleClose(false);
                  }}
                  size={40}
                  round
                />
              </FacebookMessengerShareButton>
              <span>Messenger</span>
            </ShareButtonPdp>
          </ButtonContainer>
        </ShareContainer>
        <ModalCrossbtn
          onClick={handleClose}
          src={images.CrossWhite}
          alt="share popup close"
        ></ModalCrossbtn>
      </Modal>
      {isFertilityProduct ? (
        <ShareSectionNew
          className={clickEffect}
          onClick={(e) => shareClickHandler(e)}
          newStyle={showNewPriceSection}
        >
          <img src={images.ShareIcon} alt=""></img>
        </ShareSectionNew>
      ) : (
        <ShareSection
          className={clickEffect}
          onClick={(e) => shareClickHandler(e)}
          newStyle={showNewPriceSection}
        >
          <img src={images.ShareIcon} alt=""></img>
        </ShareSection>
      )}
    </>
  );
}
